/** i18n keys for known assignment-result fields. Unknown keys stay without a note. */
export const JSON_TREE_ANNOTATION_KEYS: Readonly<Record<string, string>> = {
  ResultCount: 'RESULT_FIELD_ResultCount',
  CatalogueCount: 'RESULT_FIELD_CatalogueCount',
  StorageCount: 'RESULT_FIELD_StorageCount',
  InBothCount: 'RESULT_FIELD_InBothCount',
  CatalogueOnlyCount: 'RESULT_FIELD_CatalogueOnlyCount',
  StorageOnlyCount: 'RESULT_FIELD_StorageOnlyCount',
  ListsTruncated: 'RESULT_FIELD_ListsTruncated',
  InBoth: 'RESULT_FIELD_InBoth',
  CatalogueOnly: 'RESULT_FIELD_CatalogueOnly',
  StorageOnly: 'RESULT_FIELD_StorageOnly',
  Provider: 'RESULT_FIELD_Provider',
  ProductId: 'RESULT_FIELD_ProductId',
  NewProductCount: 'RESULT_FIELD_NewProductCount',
  ProductCount: 'RESULT_FIELD_ProductCount',
  ProductsWithKnownSize: 'RESULT_FIELD_ProductsWithKnownSize',
  EstimatedSizeInBytes: 'RESULT_FIELD_EstimatedSizeInBytes',
  DownloadedSizeInBytes: 'RESULT_FIELD_DownloadedSizeInBytes',
  SelectedCount: 'RESULT_FIELD_SelectedCount',
  AlreadyDownloadedCount: 'RESULT_FIELD_AlreadyDownloadedCount',
  AlreadyDownloadedSizeInBytes: 'RESULT_FIELD_AlreadyDownloadedSizeInBytes',
  PendingDownloadCount: 'RESULT_FIELD_PendingDownloadCount',
  PendingDownloadSizeInBytes: 'RESULT_FIELD_PendingDownloadSizeInBytes',
  PendingDownloadProductsWithKnownSize: 'RESULT_FIELD_PendingDownloadProductsWithKnownSize',
  InProgressCount: 'RESULT_FIELD_InProgressCount',
  InProgressProductsWithKnownSize: 'RESULT_FIELD_InProgressProductsWithKnownSize',
  InProgressSizeInBytes: 'RESULT_FIELD_InProgressSizeInBytes',
  MissingArchiveCount: 'RESULT_FIELD_MissingArchiveCount',
  Started: 'RESULT_FIELD_Started',
  Processed: 'RESULT_FIELD_Processed',
  Updated: 'RESULT_FIELD_Updated',
  YearsProcessed: 'RESULT_FIELD_YearsProcessed',
  DateCount: 'RESULT_FIELD_DateCount',
  RowsWritten: 'RESULT_FIELD_RowsWritten',
  SeriesCommitted: 'RESULT_FIELD_SeriesCommitted',
  DistrictDekadsPublished: 'RESULT_FIELD_DistrictDekadsPublished',
  LayersPublished: 'RESULT_FIELD_LayersPublished',
  PublishResultCount: 'RESULT_FIELD_PublishResultCount',
  ProcessedDays: 'RESULT_FIELD_ProcessedDays',
  DayReportsProcessed: 'RESULT_FIELD_DayReportsProcessed',
  Created: 'RESULT_FIELD_Created',
  RowsSaved: 'RESULT_FIELD_RowsSaved',
  BytesWritten: 'RESULT_FIELD_BytesWritten',
  ForecastResponses: 'RESULT_FIELD_ForecastResponses',
  StationsProcessed: 'RESULT_FIELD_StationsProcessed',
  DatesRendered: 'RESULT_FIELD_DatesRendered',
  ClustersWritten: 'RESULT_FIELD_ClustersWritten',
  SuccessCount: 'RESULT_FIELD_SuccessCount',
  NewBidCount: 'RESULT_FIELD_NewBidCount',
  ExportedCount: 'RESULT_FIELD_ExportedCount',
  FileStorageItemId: 'RESULT_FIELD_FileStorageItemId',
  FtpRemotePath: 'RESULT_FIELD_FtpRemotePath',
  Repaired: 'RESULT_FIELD_Repaired',
  TotalFetched: 'RESULT_FIELD_TotalFetched',
  SeasonsUpdated: 'RESULT_FIELD_SeasonsUpdated',
  PolygonCount: 'RESULT_FIELD_PolygonCount',
  SavedReports: 'RESULT_FIELD_SavedReports',
  RequestsSent: 'RESULT_FIELD_RequestsSent',
  imported: 'RESULT_FIELD_imported',
  fetched: 'RESULT_FIELD_fetched',
};

export function jsonTreeAnnotationKey(field: string): string | null {
  return JSON_TREE_ANNOTATION_KEYS[field] ?? null;
}
